import { RouteObjectRule } from "../router";
import { lazy, ReactNode, Suspense } from "react";
import { LuckLoading, LuckProgress } from '../../components/Luck';

export const lazyLoad = (children: ReactNode): ReactNode => {
	return (
		<Suspense fallback={
			<LuckProgress><LuckLoading /></LuckProgress>
		}>
			{children}
		</Suspense>
	)
}
//,美中国际网站
const Config = lazy(() => import('../../pages/Website/Config'))
const Category = lazy(() => import('../../pages/Website/Category'))
const Article = lazy(() => import('../../pages/Website/Article'))
const ArticleAdd = lazy(() => import('../../pages/Website/Article/add'))
const ArticleEdit = lazy(() => import('../../pages/Website/Article/edit'))
//广告管理
const FocusCate = lazy(() => import('../../pages/Website/Focus/category'))
const Focus = lazy(() => import('../../pages/Website/Focus'))
const FocusAdd = lazy(() => import('../../pages/Website/Focus/add'))
const FocusEdit = lazy(() => import('../../pages/Website/Focus/edit'))
const FromIndex = lazy(() => import('../../pages/Website/Form'))
//捷报
const Jiebao = lazy(() => import('../../pages/Website/Jiebao'))
const JiebaoAdd = lazy(() => import('../../pages/Website/Jiebao/add'))
const JiebaoEdit = lazy(() => import('../../pages/Website/Jiebao/edit'))


const WebsiteRouter: RouteObjectRule[] = [
	{
		path: "/website",
		children: [
			{
				element: lazyLoad(<Config />),
				path: '/website/config',
			},
			{
				element: lazyLoad(<Category />),
				path: '/website/cms/category',
			},
			{
				element: lazyLoad(<Article />),
				path: '/website/cms/article',
			},
			{
				path: "/website/cms/article/add",
				element: lazyLoad(<ArticleAdd />)
			},
			{
				path: "/website/cms/article/edit/:id",
				element: lazyLoad(<ArticleEdit />)
			},
			//广告
			{
				element: lazyLoad(<FocusCate />),
				path: '/website/cms/focuscate',
			},
			{
				element: lazyLoad(<Focus />),
				path: '/website/cms/focus',
			},
			{
				path: "/website/cms/focus/add",
				element: lazyLoad(<FocusAdd />)
			},
			{
				path: "/website/cms/focus/edit/:id",
				element: lazyLoad(<FocusEdit />)
			},
			{
				path: "/website/form",
				element: lazyLoad(<FromIndex />)
			},
			{
				element: lazyLoad(<Jiebao />),
				path: '/website/jiebao',
			},
			{
				path: "/website/jiebao/add",
				element: lazyLoad(<JiebaoAdd />)
			},
			{
				path: "/website/jiebao/edit/:id",
				element: lazyLoad(<JiebaoEdit />)
			},
		]
	}
];

export default WebsiteRouter;